const STALE_MS = 8 * 24 * 60 * 60 * 1000;

export function marketplaceSyncBadge(mp) {
  const err = mp?.lastUpdateError;
  if (err && /API key rejected/i.test(err))
    return { color: "red", label: "Auth failed" };
  if (err && /^Catalog update held/i.test(err))
    return { color: "orange", label: "Held" };
  if (err) return { color: "red", label: "Failed" };
  if (!mp?.lastSuccessfulUpdateAt) return { color: "gray", label: "Never" };
  const age = Date.now() - new Date(mp.lastSuccessfulUpdateAt).getTime();
  if (Number.isNaN(age) || age > STALE_MS) return { color: "orange", label: "Stale" };
  return { color: "teal", label: "OK" };
}
